import { Injectable } from '@angular/core';
@Injectable({
  providedIn: 'root',
})
export class TransferStoreService {
  TRANSFER_FONDS: any;
  TRANSFER_FONDS_DESTINATION: any;

  TRANSFER_DATA:{
    idFondo: string;
    transferenciaTotal: string;
    numeroCuotas: string;
    idCuentaParticipacion: string;
    idCuentaDestino: string;
    cuc: string
  }

  TRANSFER_CONFIRM_DATA:any;

  TRANSFER_OPERATION:{
    idOperacion: string;
  }

  //
  constructor() {}
}
